


import { NGXLogger } from "ngx-logger";
import { ConfirmationService, MessageService } from "primeng/api";


import {
  DialogService,
  DynamicDialogConfig,
  DynamicDialogRef,
} from "primeng/dynamicdialog";


import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { Subject } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { StoricoPratica } from "src/app/models/pratica.storico.model";
import { StiliService } from "src/app/services/stili.service";
import { UtilService } from "src/app/services/util.service";
import { ExcelService } from "src/app/services/excelService.service";
import { PraticaFlowdy2_Firestore } from "src/app/models/praticaFirestore.model";
import { StoricoOda } from "src/app/models/oda.storico.model";
import { Component, OnInit } from "@angular/core";
import { OdaService } from "src/app/services/oda.service";
import { Oda } from "src/app/models/oda.model";
import { OdaAtFirestore } from "src/app/models/odaAtFirestore.model";
import { StoricoAggregatoOda } from "src/app/models/oda.storicoAggregato.model";


@Component({
    selector: "app-storico-oda2",
    templateUrl: './storico-oda.component.html',
    styleUrls: ["../oda.component.css"],
  })
  export class StoricoOdaComponent implements OnInit {


    protected _onDestroy = new Subject<void>();

    protected storico:StoricoOda[]=[];
    protected storicoAggregato:StoricoAggregatoOda[]=[];
    protected oda: OdaAtFirestore;

    protected ref: DynamicDialogRef;
    isLoadingResults = false;

    constructor(
        private logger: NGXLogger,
        public dialogRef: DynamicDialogRef,
        public config: DynamicDialogConfig,
        public confirmationService:ConfirmationService,
        public dialogService: DialogService,
        private stiliService:StiliService ,
        private utilService:UtilService,
        private excelService:ExcelService,
        private messageService: MessageService,
        public odaService:OdaService,
      ) {

      //this.storico = this.config.data.storico;
      this.oda = this.config.data.oda;
      //this.logger.info(this.storico);
    }

   
    ngOnInit(): void {
      this.loadStorico();



    }

    loadStorico(){
      this.isLoadingResults = true;
      this.odaService.getStorico(this.oda.id.toString()).subscribe( {
        next: (v) => {
          this.storico = v;
          this.isLoadingResults = false;
          //this.aggregaRighe(v);
        },
        error: (e) => {
            this.messageService.add({life: 10000,severity:'error', summary:'Errore', detail:'Errore in fase di recupero dello storico dell\'ODA'});
            this.isLoadingResults = false;
        },
        complete: () => {
        
        }
      });
    }

    aggregaRighe(storico:StoricoOda[]){
      const aggregati: { [key: string]: StoricoAggregatoOda } = {};
      storico.forEach(recordStorico => {
        if (!recordStorico.data || !recordStorico.operazione) return;

        if(recordStorico.operazione.startsWith("CREAZIONE")){
          this.storicoAggregato.push({
            operazione: "CREATO PER UN VALORE DI "+ recordStorico.valore + " €",
            data: recordStorico.data,
            valoreTotale: recordStorico.valore
          });
         }else{
          this.logger.info(recordStorico.operazione + " "+  recordStorico.data);
          const dataObj = recordStorico.data instanceof Date ? recordStorico.data : new Date(recordStorico.data);

          // Verifica che la conversione abbia prodotto una data valida
          if (isNaN(dataObj.getTime())) {
            console.warn(`Data non valida per il record:`, recordStorico);
            return;
          }
      
          const dataChiave = dataObj.toISOString().split('T')[0]; // Ottiene la data in formato YYYY-MM-DD
          const chiave = `${recordStorico.operazione}-${dataChiave}`;
          if (!aggregati[chiave]) {
            aggregati[chiave] = {
              operazione: recordStorico.operazione,
              data: new Date(dataChiave),
              valoreTotale: 0
            };
          }
    
          // Somma il valore
          aggregati[chiave].valoreTotale += recordStorico.valore || 0;
          this.storicoAggregato.push(aggregati[chiave]);
          this.logger.info(aggregati[chiave]);
        }
      });

     
      this.storicoAggregato = [...this.storicoAggregato];
      this.isLoadingResults = false;
      
      this.logger.info(this.storicoAggregato);
    }
   
    formattaStorico(storico:StoricoOda):string{
       if(storico.operazione.startsWith("CREAZIONE")){
        //this.logger.info("> CREAZIONE" + storico.data);
        return "CREATO PER UN VALORE DI "+ storico.valore + " €";
      }else if(storico.operazione.startsWith("MODIFICATO VALORE IMPEGNATO")){
        //this.logger.info("> IMPEGNATO" + storico.data);
        //todo
      }else if(storico.operazione.startsWith("MODIFICATO VALORE DOVUTO PER FINE FASE 1")){
        //this.logger.info("> DOVUTO" + storico.data);
        //todo
      } 
      return storico.operazione;
    }

    scaricaReportStorico(){
      //this.excelService.exportStoricoFase1ToExcel(this.storico, 'storico_fase1_'+this.pratica.cui+'.xlsx');
    }
    
  }


  /*   */
          //this.storico = v;

          //this.aggregaRighe();